import React from 'react';
import { CTAButton } from './CTAButton';
import { Countdown } from './Countdown';
export function FinalCTA() {
  return <section className="w-full bg-ofm-900 px-5 py-14 sm:px-6 sm:py-20" data-id="element-92" data-mp="3udp26xtznyt6">
      <div className="mx-auto w-full max-w-2xl text-center" data-id="element-93" data-mp="c7aew89tyci4">
        <h2 className="font-display text-[28px] font-extrabold leading-tight text-white sm:text-4xl" data-id="element-94" data-mp="c4oa2gebqb3l">
          La próxima vez que un niño se siente en tu sillón…
        </h2>

        <p className="mt-5 text-[15px] leading-relaxed text-ofm-100/85 sm:text-lg" data-id="element-95" data-mp="m3drk82b5tjb">
          Podrás seguir improvisando… o podrás tener un sistema que te guíe desde el
          diagnóstico hasta la elección del aparato correcto.
        </p>
        <p className="mt-4 text-[15px] font-semibold leading-relaxed text-white sm:text-lg" data-id="element-96" data-mp="qvx3z1p9eimj">
          La decisión que tomes hoy puede cambiar la forma en que abordarás cada caso
          a partir de ahora.
        </p>

        <div className="mt-8" data-id="element-97" data-mp="zx4q6lei3t09">
          <CTAButton variant="gold" label="🦷 QUIERO EL SISTEMA OFM POR SOLO $12.99" data-id="element-98" data-mp="zxy200sbh8p9" />
          <p className="mt-3 text-[12px] font-medium text-ofm-200 sm:text-sm" data-id="element-99" data-mp="2c6rc6bq0skpp">
            Descarga inmediata • Pago único • Acceso de por vida • Garantía de 7 días
          </p>
        </div>

        <div className="mt-8" data-id="element-100" data-mp="2m4xakjcmb8pt">
          <Countdown tone="dark" label="Tu precio promocional expira en" data-id="element-101" data-mp="2r1nqn6ofa4b8" />
        </div>
      </div>
    </section>;
}